import { IConfigurationData } from '../../../../../../../../types/product.configuration.types';
import ConfigurationListingCard from '../ConfigurationListingCard/ConfigurationListingCard';
import './ConfigurationListingTableBody.scss';

const ConfigurationListingTableBody = ({
  configurations,
  loading,
  totalConfigurationCount
}: {
  configurations: IConfigurationData[];
  loading: boolean;
  totalConfigurationCount: number;
}) => {
  const isEmptyData = totalConfigurationCount === 0;
  const searchIsEmpty = configurations?.length === 0;

  if (loading) {
    return (
      <div className="configurationListingTableBody">
        {[1, 2, 3].map(item => (
          <div key={item} className="configurationCardSkeleton">
            <div className="skeletonLine" />
            <div className="skeletonLine" />
            <div className="skeletonLine" />
          </div>
        ))}
      </div>
    );
  }

  if (isEmptyData || searchIsEmpty) {
    return (
      <div className="configurationListingTableBody">
        <div className="noDataMessage">
          {isEmptyData ? 'No hay configuraciones disponibles' : searchIsEmpty ? 'No se encontraron resultados' : ''}
        </div>
      </div>
    );
  }

  return (
    <div className="configurationListingTableBody">
      {configurations?.map(configuration => (
        <ConfigurationListingCard key={configuration.id} configuration={configuration} />
      ))}
    </div>
  );
};

export default ConfigurationListingTableBody;
